import React from 'react';

import { useLocation } from 'react-router-dom';

import Offline from 'src/components/layout/Offline.tsx';
import AuthContext from 'src/features/auth/context/AuthContext';
import { useParkingStatus } from 'src/features/parkingManagement/hooks/useParkingStatus';
import { cn } from 'src/utils';

interface MainLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
}

const MainLayout = ({ children, className }: MainLayoutProps) => {
    const location = useLocation();

    const { available, isConnectionError } = useParkingStatus();
    const isParkingOffline = !available;
    const { permissionsLoaded } = React.useContext(AuthContext);

    const pathsToDisplayOffline = [
        '/profile',
        '/public-information',
        '/entry-exit-points',
        '/points-of-interest',
        '/amenities',
        '/general-settings',
        '/integrations',
        '/payment-providers',
        '/additional-services',
        '/parking-admin',
    ];

    const showPageWhenOffline = pathsToDisplayOffline.some((path) => location.pathname.includes(path));

    return (
        <main
            className={cn(
                'relative flex flex-1 flex-col gap-4 sm:gap-6',
                isParkingOffline && !showPageWhenOffline
                    ? 'flex h-[70vh] w-full flex-1 items-center justify-center'
                    : '',
                className,
            )}
        >
            {(isParkingOffline || isConnectionError) && !showPageWhenOffline && permissionsLoaded ? (
                <Offline />
            ) : (
                children
            )}
        </main>
    );
};

export default MainLayout;
